import { FC } from "react";
import { Menu, MenuProps } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { SubMenuItem } from "src/constants/modules";
import { OverflowIndicator } from "src/Modules/MainMenu/constants";

type Props = Omit<MenuProps, "items"> & { items: SubMenuItem[] };

const ModulesMenuWeb: FC<Props> = ({ items, ...rest }) => {
  const { t } = useTranslation();
  const usedItems: MenuProps["items"] = items
    .filter((item) => item.underMenu === "Main")
    .map(({ key, label, icon, route }) => ({ key, label: <Link to={`/${route}`}>{t(label)}</Link>, icon }));
  return (
    <Menu
      mode="horizontal"
      overflowedIndicator={<OverflowIndicator />}
      overflowedIndicatorPopupClassName="h-full!"
      className="[&_.ant-menu-item::after]:!hidden [&_.ant-menu-item-selected::after]:!hidden border-none! w-full! flex! justify-center! bg-background-default!"
      classNames={{
        item: "flex! items-center! justify-start! h-full! border-none!",
        itemIcon: "w-5! h-5!",
      }}
      style={{ minWidth: 0 }}
      items={usedItems}
      {...rest}
    ></Menu>
  );
};

export default ModulesMenuWeb;
